import { useOne } from '@refinedev/core';

export type Family = {
  id: string;
  name: string;
  advisorUserId: string;
  mainFamilyMember: { clientId: string };
  secondaryFamilyMembers: {
    clientId: string;
    relationshipToMainFamilyMember: Relation;
  }[];
  createdAt: string;
};

export type Relation = 'Spouse' | 'Partner' | 'Child' | 'Sibling' | 'Other';

export const useFamily = (familyId?: string) => {
  const { data, isLoading, isError, refetch } = useOne<Family>({
    resource: 'families',
    id: familyId || '',
    queryOptions: {
      enabled: !!familyId,
    },
  });

  return {
    family: data?.data,
    isLoading,
    isError,
    refetch,
  };
};
